import { Chip as MuiChip, styled, Typography } from '@mui/material'

export const Chip = styled(MuiChip, {
  shouldForwardProp: (prop) => prop !== 'disableRipple',
})`
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(0, 1)};
  border-color: ${({ theme }) => theme.palette.common.divider};
  background-color: ${({ theme }) => theme.palette.grey[50]};
  min-height: fit-content;

  &.MuiChip-clickable:hover {
    background-color: ${({ theme }) => theme.palette.grey[50]};
  }
  > .MuiChip-label {
    padding: 0;
  }
`

export const ChipLabel = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  padding: 0;
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-word;
`
